/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Select_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Select Style Guide" |
*
* @param {Style_Guide_Select_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_select_aria_label = /** @type {((inputs?: Style_Guide_Select_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Select_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner le guide de style")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stilrichtlinien auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona la guida di stile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите руководство по стилю")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar guía de estilo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择样式指南")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイルガイドを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्टाइल गाइड चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o Guia de Estilo")
	return /** @type {LocalizedString} */ ("Select Style Guide")
});